export const calendarTabs = [
  {
    path: '/calendar-range',
    title: 'date_flight',
  },
  {
    path: '/select-nights',
    title: 'tours_block.how_many_nights',
  },
]
